import React, {useState} from 'react';
import {Helmet} from "react-helmet";
import moment from "moment";
import {useForm} from "react-hook-form";
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import LoadingButton from "../../base/components/loadingButton";
import BlockUi from "@availity/block-ui";
import axios from "../../../helpers/axios";
import {Table} from "reactstrap";
import numberFormat from "../../../helpers/numberFormat";
import {Form} from "react-bootstrap";
import _ from "lodash"

const OsvWsIncome = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()

  const [onlyDebtor, setOnlyDebtor] = useState(true)
  const defaultVal= {
    start: moment().subtract(7, 'days').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY'),
  }
  const formController = useForm({defaultValues:defaultVal})
  const {handleSubmit} = formController

  const submit = (data) =>{
    setLoading(true)
    axios.post('/api/fromOneC/osvWsIncome', data)
      .then(({data})=>{
        setData(data)
      })
      .finally(()=>setLoading(false))
  }

  const filteredData = _.filter(data?.data, r=>r.total>0)
  return (
    <>
      <Helmet><title>Осв и доход</title></Helmet>
      <BlockUi blocking={loading}>
        <Portlet>
          <PortletHeader title={<><Form.Label className={'d-flex align-items-center gap-2'} id={"notVisible"}>
            <input
              checked={onlyDebtor}
              onChange={() => setOnlyDebtor(!onlyDebtor)}
              type={"checkbox"}
            />{" "}
            Показывать только должников
          </Form.Label>

          </>} toolbar={<PortletHeaderToolbar>
            <form onSubmit={handleSubmit(submit)} className={'d-flex gap-2'}>
              <CustomDatePicker formController={formController}
                                label={"Дата c"}
                                value={defaultVal.start}
                                name={`start`}
                                rules={{required: true}}/>
              <CustomDatePicker formController={formController}
                                label={"Дата по"}
                                value={defaultVal.end}
                                name={`end`}
                                rules={{required: true}}/>
              <LoadingButton loading={loading} title={'Получить'}/>
            </form>
          </PortletHeaderToolbar>}/>
          <div className={'p-2'}>
            {data && data.info.length>0 && data.info.map((info,index)=>{
              return <React.Fragment key={index}>
                {info.name} нет в осв, купил на сумму {numberFormat(info.netto)}{index+1 !== data.info.length ? '; ':''}
              </React.Fragment>
            })}
          </div>
          {data && <Table size={'sx'} bordered>
            <thead>
            <tr>
              <td>Контрагент</td>
              <td>Выкупленно в Амадеус</td>
              <td>Оплачено</td>
              <td>Еще должны</td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th>Итого</th>
              <th>{numberFormat(_.sumBy(onlyDebtor ? filteredData : data.data, 'amadeus'))}</th>
              <th>{numberFormat(_.sumBy(onlyDebtor ? filteredData : data.data, 'flowCr'))}
                <br/>
                <div style={{fontSize:8}}>тут не только в Амадеус</div> </th>
              <th>{numberFormat(_.sumBy(onlyDebtor ? filteredData : data.data, r => {
                const total = r.amadeus - r.flowCr
                if(total>0) return total
              }))}</th>
            </tr>
            {(onlyDebtor ? filteredData : data.data).map((row, index) => {
              return <tr key={index}>
                <td>{row.counterparty.agentCode === "000000004" ? '📌 ' : ''} {row.counterparty.name}</td>
                <td>{numberFormat(row.amadeus)}</td>
                <td>{numberFormat(row.flowCr)}</td>
                <td>{numberFormat(row.total)}</td>
              </tr>
            })}

            </tbody>
          </Table>}
        </Portlet>
      </BlockUi>

    </>
  );
};

export default OsvWsIncome;
